import { Component } from '@angular/core';
import { Message } from 'primeng/primeng';
//import { Mensajes } from "app/shared/constantes/mensajes";

import { Router, NavigationEnd } from '@angular/router';


//import { environment } from 'environments/environment';
import { MensajesConstantes } from '../constantes/mensajes';
import { Constantes } from '../constantes/constantes';
import { environment } from '../../../environments/environment';


@Component({
	selector: 'loading-indicator',
	template: `<style type='text/css'>
    #floatingBarsG{
	position:relative;
	width:110px;
	height:110px;
	margin:auto;
}

.blockG{
	position:absolute;
	background-color:rgb(255,255,255);
	width:9px;
	height:23px;
	border-radius:8px 8px 0 0;
		-o-border-radius:8px 8px 0 0;
		-ms-border-radius:8px 8px 0 0;
		-webkit-border-radius:8px 8px 0 0;
		-moz-border-radius:8px 8px 0 0;
	transform:scale(0.4);
		-o-transform:scale(0.4);
		-ms-transform:scale(0.4);
		-webkit-transform:scale(0.4);
		-moz-transform:scale(0.4);
	animation-name:fadeG;
		-o-animation-name:fadeG;
		-ms-animation-name:fadeG;
		-webkit-animation-name:fadeG;
		-moz-animation-name:fadeG;
	animation-duration:1.04s;
		-o-animation-duration:1.04s;
		-ms-animation-duration:1.04s;
		-webkit-animation-duration:1.04s;
		-moz-animation-duration:1.04s;
	animation-iteration-count:infinite;
		-o-animation-iteration-count:infinite;
		-ms-animation-iteration-count:infinite;
		-webkit-animation-iteration-count:infinite;
		-moz-animation-iteration-count:infinite;
	animation-direction:normal;
		-o-animation-direction:normal;
		-ms-animation-direction:normal;
		-webkit-animation-direction:normal;
		-moz-animation-direction:normal;
}

#rotateG_01{
	left:0;
	top:27px;
	animation-delay:0.39s;
		-o-animation-delay:0.39s;
		-ms-animation-delay:0.39s;
		-webkit-animation-delay:0.39s;
		-moz-animation-delay:0.39s;
	transform:rotate(-90deg);
		-o-transform:rotate(-90deg);
		-ms-transform:rotate(-90deg);
		-webkit-transform:rotate(-90deg);
		-moz-transform:rotate(-90deg);
}

#rotateG_02{
	left:8px;
	top:9px;
	animation-delay:0.52s;
		-o-animation-delay:0.52s;
		-ms-animation-delay:0.52s;
		-webkit-animation-delay:0.52s;
		-moz-animation-delay:0.52s;
	transform:rotate(-45deg);
		-o-transform:rotate(-45deg);
		-ms-transform:rotate(-45deg);
		-webkit-transform:rotate(-45deg);
		-moz-transform:rotate(-45deg);
}

#rotateG_03{
	left:25px;
	top:3px;
	animation-delay:0.65s;
		-o-animation-delay:0.65s;
		-ms-animation-delay:0.65s;
		-webkit-animation-delay:0.65s;
		-moz-animation-delay:0.65s;
	transform:rotate(0deg);
		-o-transform:rotate(0deg);
		-ms-transform:rotate(0deg);
		-webkit-transform:rotate(0deg);
		-moz-transform:rotate(0deg);
}

#rotateG_04{
	right:8px;
	top:9px;
	animation-delay:0.78s;
		-o-animation-delay:0.78s;
		-ms-animation-delay:0.78s;
		-webkit-animation-delay:0.78s;
		-moz-animation-delay:0.78s;
	transform:rotate(45deg);
		-o-transform:rotate(45deg);
		-ms-transform:rotate(45deg);
		-webkit-transform:rotate(45deg);
		-moz-transform:rotate(45deg);
}

#rotateG_05{
	right:0;
	top:27px;
	animation-delay:0.9099999999999999s;
		-o-animation-delay:0.9099999999999999s;
		-ms-animation-delay:0.9099999999999999s;
		-webkit-animation-delay:0.9099999999999999s;
		-moz-animation-delay:0.9099999999999999s;
	transform:rotate(90deg);
		-o-transform:rotate(90deg);
		-ms-transform:rotate(90deg);
		-webkit-transform:rotate(90deg);
		-moz-transform:rotate(90deg);
}

#rotateG_06{
	right:8px;
	bottom:7px;
	animation-delay:1.04s;
		-o-animation-delay:1.04s;
		-ms-animation-delay:1.04s;
		-webkit-animation-delay:1.04s;
		-moz-animation-delay:1.04s;
	transform:rotate(135deg);
		-o-transform:rotate(135deg);
		-ms-transform:rotate(135deg);
		-webkit-transform:rotate(135deg);
		-moz-transform:rotate(135deg);
}

#rotateG_07{
	bottom:0;
	left:25px;
	animation-delay:1.1700000000000002s;
		-o-animation-delay:1.1700000000000002s;
		-ms-animation-delay:1.1700000000000002s;
		-webkit-animation-delay:1.1700000000000002s;
		-moz-animation-delay:1.1700000000000002s;
	transform:rotate(180deg);
		-o-transform:rotate(180deg);
		-ms-transform:rotate(180deg);
		-webkit-transform:rotate(180deg);
		-moz-transform:rotate(180deg);
}

#rotateG_08{
	left:8px;
	bottom:7px;
	animation-delay:1.3s;
		-o-animation-delay:1.3s;
		-ms-animation-delay:1.3s;
		-webkit-animation-delay:1.3s;
		-moz-animation-delay:1.3s;
	transform:rotate(-135deg);
		-o-transform:rotate(-135deg);
		-ms-transform:rotate(-135deg);
		-webkit-transform:rotate(-135deg);
		-moz-transform:rotate(-135deg);
}



@keyframes fadeG{
	0%{
		background-color:rgb(4,17,135);
	}

	100%{
		background-color:rgb(255,255,255);
	}
}

@-o-keyframes fadeG{
	0%{
		background-color:rgb(4,17,135);
	}

	100%{
		background-color:rgb(255,255,255);
	}
}

@-ms-keyframes fadeG{
	0%{
		background-color:rgb(4,17,135);
	}

	100%{
		background-color:rgb(255,255,255);
	}
}

@-webkit-keyframes fadeG{
	0%{
		background-color:rgb(4,17,135);
	}

	100%{
		background-color:rgb(255,255,255);
	}
}

@-moz-keyframes fadeG{
	0%{
		background-color:rgb(4,17,135);
	}

	100%{
		background-color:rgb(255,255,255);
	}
}
    </style>
    <div style="padding-top: 20%; padding-bottom: 20%;">
    <div id="floatingBarsG" class="loading-indicator">
	<!---<div class="blockG" id="rotateG_01"></div>
	<div class="blockG" id="rotateG_02"></div>
	<div class="blockG" id="rotateG_03"></div>
	<div class="blockG" id="rotateG_04"></div>
	<div class="blockG" id="rotateG_05"></div>
	<div class="blockG" id="rotateG_06"></div>
	<div class="blockG" id="rotateG_07"></div>
	<div class="blockG" id="rotateG_08"></div>-->
  </div>
  </div>`
})
export class LoadingIndicator { }


export class LoadingPage extends MensajesConstantes {


	public esProduccion = environment.production;

	public mensaje: Message[] = [];
	public loading: boolean;
	private router2: Router


	/**
	 * Permite mostrar los IDs de los objetos de las tablas
	 * poner --> '*ngIf="mostrarID"'
	 */
	mostrarID: Boolean = false;


	constructor(val: boolean) {
		super();
		this.loading = val;


		this.mostrarID = Constantes.mostrarIdentificador;

		//this.mostrarID = true;

		// this.router = new Router();


	}


    /**
	 * Implementar ancla
	 * @param router2 
	 */
	public ancla(router2: Router) {
		this.router2.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				const tree = this.router2.parseUrl(this.router2.url);
				if (tree.fragment) {
					const element = document.querySelector('#' + tree.fragment);
					// if (element) { element.scrollIntoView( element ); }
				}
			}
		});
	}



	/**
	 * Permite encender el loadin
	 */
	standby() {
		this.loading = true;
	}

	/**
	 * Permite apagar el loading
	 */
	// tslint:disable-next-line:indent
	ready() {
		this.loading = false;
	}


	/** 
	 * Recupera informacion de session, de la cadena gurdada
	*/
	public getParametroGeneral(): string {
		return sessionStorage.getItem('objGeneral');
	}

	/**
	 * Carga con un objeto el parametro general lo almacena en sessionstorage como string
	 * @param objeto 
	 */
	public setParametroGeneral(objeto: any) {
		sessionStorage.setItem('objGeneral', JSON.stringify(objeto));
	}




	mostrarMensajeError(errorMessage: string): void {
		this.mensaje = [];
		this.mensaje.push({ severity: 'error', summary: 'Error', detail: errorMessage });
	}

	mostrarMensajeInfo(infoMessage: string): void {
		this.mensaje = [];
		this.mensaje.push({ severity: 'info', summary: 'Info', detail: infoMessage });
	}

	mostrarMensajeAdvertencia(infoMessage: string): void {
		this.mensaje = [];
		this.mensaje.push({ severity: 'warning', summary: 'Advertencia', detail: infoMessage });
	}



	/**
	 * Permite convertir una fecha en formato simple string,
	 * esta fecha ayudara a comparar formatos fecha
	 * aaaammdd este formato en string si se puede comparar con mayor o menor
	 * @author jaime.perez
	 * @param fecha 
	 */
	public convertirFechaAStringSimple(fecha: Date): string {

		let fechaNueva = new Date(fecha);
		let fechaString = fechaNueva.getUTCFullYear().toString() + ('0' + (fechaNueva.getUTCMonth() + 1)).slice(-2) + ('0' + (fechaNueva.getUTCDate())).slice(-2);
		return fechaString;

	}

	/**
	 * Convierte una fecha a formato utc
	 * @author julio.salinas
	 * @param fecha
	 */
	public obtenerFechaUTC(fecha: Date): Date {
		return new Date(fecha + ' 00:00:00');
	}

	/**
	 * @author lenin.gonzalez
	 * @since 20171024 1019
	 * @param mesNumero 
	 * Función para devolver el nombre de mes en base a un número.
	 * De loq ue se ha consultado hasta la fecha angular no maneja un case para
	 * número así que se manejarán multiples ifs.
	 */
	public obtenerMesLetrasMayusculas(mesNumero: number): string {
		try {
			if (mesNumero == 1) {
				return 'ENERO';
			}
			if (mesNumero == 2) {
				return 'FEBRERO';
			}
			if (mesNumero == 3) {
				return 'MARZO';
			}
			if (mesNumero == 4) {
				return 'ABRIL';
			}
			if (mesNumero == 5) {
				return 'MAYO';
			}
			if (mesNumero == 6) {
				return 'JUNIO';
			}
			if (mesNumero == 7) {
				return 'JULIO';
			}
			if (mesNumero == 8) {
				return 'AGOSTO';
			}
			if (mesNumero == 9) {
				return 'SEPTIEMBRE';
			}
			if (mesNumero == 10) {
				return 'OCTUBRE';
			}
			if (mesNumero == 11) {
				return 'NOVIEMBRE';
			}
			if (mesNumero == 12) {
				return 'DICIEMBRE';
			} else {
				return 'NO EXISTE';
			}

		} catch (error) {
			console.error('ERROR. obtenerMesLetras: ' + error.mensajeError);
			return 'Error obtenerMesLetras ';
		}
	}



	/**
	 * @author lenin.gonzalez
	 * @since 20171024 1026
	 * @param diaNumero 
	 * Función para devolver el nombre del día en base a un número.
	 * De lo que se ha consultado hasta la fecha angular no maneja un case para
	 * número así que se manejarán multiples ifs.
	 */
	public obtenerDiaLetrasMayusculas(diaNumero: number): string {
		try {
			if (diaNumero == 1) {
				return 'LUNES';
			}
			if (diaNumero == 2) {
				return 'MARTES';
			}
			if (diaNumero == 3) {
				return 'MIÉRCOLES';
			}
			if (diaNumero == 4) {
				return 'JUEVES';
			}
			if (diaNumero == 5) {
				return 'VIERNES';
			}
			if (diaNumero == 6) {
				return 'SÁBADO';
			}
			if (diaNumero == 7) {
				return 'DOMINGO';
			} else {
				return 'NO EXISTE';
			}


		} catch (error) {
			console.error('ERROR. obtenerDiaLetrasMayusculas: ' + error.mensajeError);
			return 'Error obtenerDiaLetras ';
		}
	}
}
